import { useRouter } from 'next/router';
import React from 'react';
import { Href } from '~/components/Link';
export interface RedirectProps {
  pathname: Href['pathname'];
  query?: Href['query'];
}
export const Redirect: React.FC<RedirectProps> = ({
  pathname,
  query
}: RedirectProps): null => {
  const router = useRouter();
  React.useEffect((): void => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.push({
      pathname,
      query
    });
  }, [pathname, query]);
  return null;
};
export default Redirect;